/*@flow*/
import isFunction from './isFunction';
import isNil from './isNil';
import isString from './isString';
import fail from './fail';
import stringify from './stringify';

function assert(guard: boolean, message: string | (() => string | void)) {
  if (guard !== true) {
    let message2 = message;
    if (isFunction(message)) {
      // handle lazy messages
      message2 = message();
    } else if (isNil(message)) {
      // use a default message
      message2 =
        'Assert failed (turn on "Pause on exceptions" in your Source panel)';
    }
    isString(message2) && assert.fail(message2);
  }
}

assert.fail = fail;
assert.stringify = stringify;

export default assert;
